import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// CC BUDGET AMENDMENT RELATED APIs
// ==============================================

// 1. Get Approval CC Amend Budget Details (Main Grid)
export const getApprovalCCAmendBudgetDetails = async (roleId, uid) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetApprovalCCAmendBudgetCDetails?Roleid=${roleId}&UID=${uid}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get Approval CC Amend Budget by ID (Detail View)
export const getApprovalCCAmendBudgetById = async (amendId, amendType) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetApprovalCCAmendBudgetById?AmendId=${amendId}&AmendType=${amendType}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Get CC Upload Documents Exists
export const getCCUploadDocsExists = async (ccCode, uid) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/Getccuploadocsexists?CCCode=${ccCode}&UID=${uid}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. Approve Cost Center Budget Amendment
export const approveCostCenterBudgetAmend = async (approvalData) => {
    try {
        
        // Log a sample of the data being sent
        
        const response = await axios.put(
            `${API_BASE_URL}/Accounts/ApproveCostCenterBudgetAmend`,
            approvalData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                timeout: 30000 // 30 second timeout for complex operations
            }
        );
        
        
        return response.data;
        
    } catch (error) {
        
        if (error.response) {
            // Server responded with error status
            
            // Log specific error details for 400 errors
            if (error.response.status === 400) {
            }
            
        } else if (error.request) {
            // Request was made but no response received
        } else {
            // Something else happened
        }
        
        
        // Return more specific error information
        if (error.response?.data) {
            throw error.response.data;
        } else if (error.response?.status === 400) {
            throw new Error('Bad Request: Invalid data format or missing required fields');
        } else if (error.response?.status === 500) {
            throw new Error('Server Error: Please contact administrator');
        }
        
        throw error;
    }
};

// 5. Save CC Amend Budget (Creation)
export const saveCCAmendBudget = async (budgetData) => {
    try {
        
        const response = await axios.post(
            `${API_BASE_URL}/Accounts/SaveCCAmendBudget`,
            budgetData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                timeout: 30000
            }
        );
        
        
        return response.data;
        
    } catch (error) {
        
        if (error.response) {
        } else if (error.request) {
        } else {
        }
        
        
        if (error.response?.data) {
            throw error.response.data;
        } else if (error.response?.status === 400) {
            throw new Error('Bad Request: Invalid budget data or missing required fields');
        } else if (error.response?.status === 500) {
            throw new Error('Server Error: Please contact administrator');
        }
        
        throw error;
    }
};

// 6. Update CC Amend Budget (Return/Update/Correction Submission)
export const updateCCAmendBudget = async (updateData) => {
    try {
        
        // Log a sample of the data being sent
        
        const response = await axios.put(
            `${API_BASE_URL}/Accounts/UpdateCCAmendBudget`,
            updateData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                timeout: 30000
            }
        );
        
        
        return response.data;
        
    } catch (error) {
        
        if (error.response) {
            
            if (error.response.status === 400) {
            }
            
        } else if (error.request) {
        } else {
        }
        
        
        if (error.response?.data) {
            throw error.response.data;
        } else if (error.response?.status === 400) {
            throw new Error('Bad Request: Invalid update data or missing required fields');
        } else if (error.response?.status === 500) {
            throw new Error('Server Error: Please contact administrator');
        }
        
        throw error;
    }
};